/* @flow */
import gql from 'graphql-tag';
import * as React from 'react';
import { graphql } from 'react-apollo';

import ClassCardSection from 'settings/components/ClassCardSection.jsx';
import Divider from 'components/Divider.jsx';
import classesDefaultsFragment from 'groups/fragments/classesDefaultsFragment.gql';
import Group from 'entities/Group';
import GroupCreateModal from 'groups/components/GroupCreateModal.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';

type Props = {
  loading?: ?boolean,
  ownedClasses: Group[],
  onCreate: (group: Group) => void,
  permissions: Object,
};

export function OwnedClassesSection(props: Props) {
  const { loading, onCreate, ownedClasses, permissions } = props;

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="OwnedClassesSection-section">
      <ClassCardSection
        label="Classes owned"
        items={ownedClasses}
        addModal={<GroupCreateModal onCreate={onCreate} />}
        addText="Create a class"
        addEnabled={permissions.can_create_group}
      />
      <Divider size="large" />
    </div>
  );
}

const withData = graphql(
  gql`
    query OwnedClassesSection {
      me {
        id
        uuid
        permissions {
          can_create_group
        }
        ownedClasses: classes(classType: "owned") {
          # TODO remove Backbone entities from the child components so we don't have to fetch everything
          ...classesDefaults
        }
      }
    }
    ${classesDefaultsFragment}
  `,
  {
    options: { fetchPolicy: 'cache-and-network' },
    props: ({ data }) => {
      const defaultMe = {
        id: null,
        ownedClasses: [],
        permissions: {},
      };

      const me = data.me || defaultMe;

      const ownedClasses = me.ownedClasses.map(group => Group.fromJSON(group));
      const { permissions } = me;

      return {
        ...data,
        ownedClasses,
        permissions,
      };
    },
  }
);

export default withData(OwnedClassesSection);
